import * as rrd from 'react-router-dom';

import { supportConfig } from '@/config';
import { CURRENT_YEAR } from '@/constants';

const { Link } = rrd.default ?? rrd;

const Footer = () => {
  const devUrl = import.meta.env.VITE_DEV_URL?.trim();
  const devName = import.meta.env.VITE_DEV_NAME?.trim();

  const { bmac, stripe, hasSupport } = supportConfig;

  const brandCol = hasSupport ? 'col-md-5' : 'col-md-5';
  const legalCol = hasSupport ? 'col-md-2' : 'col-md-3';
  const supportCol = hasSupport ? 'col-md-2' : '';
  const contactCol = hasSupport ? 'col-md-3' : 'col-md-4';

  return (
    <footer className="py-5 mt-5 border-top">
      <div className="container">
        <div className="row">
          {/* Brand */}
          <div className={`${brandCol} mb-4 mb-md-0`}>
            <h5 className="mb-3">Convert Playlist</h5>

            <p className="text-muted mb-0">
              The easiest way to move your music between platforms.
            </p>
          </div>

          {/* Legal */}
          <div className={`${legalCol} mb-4 mb-md-0`}>
            <h6 className="mb-2">Legal</h6>

            <ul className="list-unstyled small mb-0">
              <li className="mb-2">
                <Link
                  to="/privacy-policy"
                  className="text-decoration-none text-secondary"
                >
                  Privacy Policy
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to="/terms-of-service"
                  className="text-decoration-none text-secondary"
                >
                  Terms of Service
                </Link>
              </li>

              <li className="mb-2">
                <Link
                  to="/cookie-policy"
                  className="text-decoration-none text-secondary"
                >
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          {hasSupport && (
            <div className={`${supportCol} mb-4 mb-md-0`}>
              <h6 className="mb-2">
                <Link to="/support" className="text-decoration-none text-black">
                  Support
                </Link>
              </h6>

              <ul className="list-unstyled small mb-0">
                <li className="mb-2">
                  <Link
                    to="/support"
                    className="text-decoration-none text-secondary"
                  >
                    Crypto
                  </Link>
                </li>

                <li className="mb-2">
                  {stripe ? (
                    <a
                      href={stripe}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-secondary"
                    >
                      Card & Wallets
                    </a>
                  ) : (
                    <span className="text-muted">Card & Wallets</span>
                  )}
                </li>

                <li className="mb-2">
                  {bmac ? (
                    <a
                      href={bmac}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-secondary"
                    >
                      Buy Me a Coffee
                    </a>
                  ) : (
                    <span className="text-muted">Buy Me a Coffee</span>
                  )}
                </li>
              </ul>
            </div>
          )}

          {/* Contact */}
          <div className={`${contactCol} mb-4 mb-md-0`}>
            <h6 className="mb-2">Contact</h6>

            <ul className="list-unstyled small mb-0">
              <li className="mb-2">
                <a
                  href="mailto:contact@convertplaylist.net"
                  className="text-decoration-none text-secondary"
                >
                  contact@convertplaylist.net
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="my-4" />

        <div className="text-center text-muted">
          <small>
            © {CURRENT_YEAR} Convert Playlist. All rights reserved.
          </small>

          {devName && (
            <>
              <span className="mx-2">•</span>
              <small>
                Built by{' '}
                {devUrl ? (
                  <a
                    href={devUrl}
                    className="text-decoration-none text-secondary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {devName}
                  </a>
                ) : (
                  devName
                )}
              </small>
            </>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
